var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import axios from "axios";
import JSZip from "jszip";
function validatePhone(phone) {
  const reg2 = /^1[3-9](\d){9}$/;
  return reg2.test(phone);
}
function validateEmail(email) {
  const reg2 = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
  return reg2.test(email);
}
function validateIdCard(idCard) {
  const reg2 = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/;
  return reg2.test(idCard);
}
function validateCreditCode(code) {
  const reg2 = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/;
  return reg2.test(code);
}
function validateUrl(url) {
  const reg2 = /^((https?|ftp|file):\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
  return reg2.test(url);
}
function validateChinese(value) {
  const reg2 = /[\u4e00-\u9fa5]/gm;
  return reg2.test(value);
}
function validateNumber(value) {
  const reg2 = /^\d+$/;
  return reg2.test(value);
}
function validateLetter(value) {
  const reg2 = /^[a-z]+$/i;
  return reg2.test(value);
}
function validateLetterOrNumber(value) {
  const reg2 = /^[a-z0-9]+$/i;
  return reg2.test(value);
}
function validateLetterAndNumber(value) {
  const reg2 = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]*$/i;
  return reg2.test(value);
}
function validateRtmp(value) {
  const reg2 = /^((rtmp|rtmps):\/\/).*$/;
  return reg2.test(value);
}
function validateNickname(value) {
  const reg2 = /^[a-zA-Z]*$/;
  return reg2.test(value);
}
var validate = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  validatePhone,
  validateEmail,
  validateIdCard,
  validateCreditCode,
  validateUrl,
  validateChinese,
  validateNumber,
  validateLetter,
  validateLetterOrNumber,
  validateLetterAndNumber,
  validateRtmp,
  validateNickname
});
async function downloadZip(data) {
  const zip = new JSZip();
  const promiseList = [];
  data.forEach((item) => {
    const p = new Promise((resolve) => {
      axios({
        method: "get",
        url: item.url,
        responseType: "arraybuffer"
      }).then((res) => {
        resolve({
          name: item.name,
          blob: res.data
        });
      });
    });
    promiseList.push(p);
  });
  const cache = {};
  Promise.all(promiseList).then((blobList) => {
    blobList.forEach((item) => {
      if (cache[item.name] >= 0) {
        ++cache[item.name];
        const idx = item.name.lastIndexOf(".");
        const name = item.name.slice(0, idx).concat(`(${cache[item.name]})`, item.name.slice(idx));
        zip.file(name, item.blob, { binary: true });
      } else {
        cache[item.name] = 0;
        zip.file(item.name, item.blob, { binary: true });
      }
    });
    zip.generateAsync({ type: "blob" }).then((blob) => {
      const link = document.createElement("a");
      const url = window.URL.createObjectURL(blob);
      link.href = url;
      link.download = "\u7D20\u6750\u4E0B\u8F7D.zip";
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      if (link.parentNode !== null) {
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        throw Error("parentNode null");
      }
    });
  });
}
function download(url, fileName) {
  axios.get(url, { responseType: "blob" }).then((res) => {
    const { data, headers } = res;
    const blob = new Blob([data], { type: headers["content-type"] });
    const link = document.createElement("a");
    const url2 = window.URL.createObjectURL(blob);
    link.href = url2;
    link.download = fileName;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    if (link.parentNode !== null) {
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url2);
    } else {
      throw Error("parentNode null");
    }
  });
}
function delayPromise(duration) {
  return new Promise(function(resolve) {
    setTimeout(() => {
      resolve(null);
    }, duration);
  });
}
function deepClone(obj, map = /* @__PURE__ */ new WeakMap()) {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }
  if (map.has(obj))
    return map.get(obj);
  const copy = Array.isArray(obj) ? [] : {};
  map.set(obj, copy);
  const keys = Reflect.ownKeys(obj);
  keys.forEach((key) => {
    copy[key] = deepClone(obj[key], map);
  });
  return copy;
}
function dataURLtoFile(dataUrl, filename) {
  const arr = dataUrl.split(",");
  const str = window.atob(arr[1]);
  let n = str.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = str.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: "image/png"
  });
}
function encryptionPhone(phone) {
  return phone.replace(phone.substring(3, 7), "****");
}
function checkSourceValid(url) {
  return new Promise((resolve, reject) => {
    try {
      const http = new XMLHttpRequest();
      http.open("HEAD", url);
      http.onreadystatechange = function() {
        if (this.readyState == this.DONE) {
          if (this.status != 404) {
            resolve(true);
          }
          resolve(false);
        }
      };
      http.send(null);
    } catch (error) {
      reject(error);
    }
  });
}
function filenameSuffix(filename) {
  const idx = filename.lastIndexOf(".");
  return filename.slice(idx).toLowerCase();
}
var tools = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  downloadZip,
  download,
  delayPromise,
  deepClone,
  dataURLtoFile,
  encryptionPhone,
  checkSourceValid,
  filenameSuffix
});
const digitUppercase = (n) => {
  const fraction = ["\u89D2", "\u5206"];
  const digit = ["\u96F6", "\u58F9", "\u8D30", "\u53C1", "\u8086", "\u4F0D", "\u9646", "\u67D2", "\u634C", "\u7396"];
  const unit = [
    ["\u5143", "\u4E07", "\u4EBF"],
    ["", "\u62FE", "\u4F70", "\u4EDF"]
  ];
  n = Math.abs(n);
  let s = "";
  for (let i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, "");
  }
  s = s || "\u6574";
  n = Math.floor(n);
  for (let i = 0; i < unit[0].length && n > 0; i++) {
    let p = "";
    for (let j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p;
      n = Math.floor(n / 10);
    }
    s = p.replace(/(零.)*零$/, "").replace(/^$/, "\u96F6") + unit[0][i] + s;
  }
  return s.replace(/(零.)*零元/, "\u5143").replace(/(零.)+/g, "\u96F6").replace(/^整$/, "\u96F6\u5143\u6574");
};
function formatDurationTime(duration) {
  if (!duration)
    return "-";
  const oneHour = 3600 * 1e3;
  const oneDay = oneHour * 24;
  if (duration < oneHour) {
    return (duration / 1e3 / 60).toFixed(2) + " \u5206\u949F";
  } else if (duration < oneDay) {
    return (duration / 1e3 / 60 / 60).toFixed(2) + " \u5C0F\u65F6";
  }
  return (duration / 1e3 / 60 / 60 / 24).toFixed(2) + " \u5929";
}
function formatSize(size) {
  if (!size)
    return "0.00 KB";
  const kb = size / 1024;
  const mb = kb / 1024;
  const gb = mb / 1024;
  const tb = gb / 1024;
  if (Math.abs(tb) >= 1) {
    return tb.toFixed(2) + " TB";
  }
  if (Math.abs(gb) >= 1) {
    return gb.toFixed(2) + " GB";
  }
  if (Math.abs(mb) >= 1) {
    return mb.toFixed(2) + " MB";
  }
  return kb.toFixed(2) + " KB";
}
var format = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  digitUppercase,
  formatDurationTime,
  formatSize
});
const set = (key, value) => {
  if (!key)
    return;
  if (typeof value !== "string") {
    value = JSON.stringify(value);
  }
  window.localStorage.setItem(key, value);
};
const get = (key) => {
  if (!key)
    return;
  return window.localStorage.getItem(key);
};
const remove = (key) => {
  if (!key)
    return;
  window.localStorage.removeItem(key);
};
var store = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  set,
  get,
  remove
});
class PollingService {
  constructor() {
    __publicField(this, "isPolling");
    __publicField(this, "startTime");
    this.isPolling = false;
    this.startTime = 0;
  }
  async start(onPolling, interval, opts) {
    if (this.isPolling)
      return;
    this.isPolling = true;
    this.startTime = Date.now();
    while (this.isPolling) {
      if ((opts == null ? void 0 : opts.timeout) && Date.now() - this.startTime > opts.timeout) {
        this.stop();
        return Promise.resolve("timeout");
      }
      await onPolling();
      if (!this.isPolling)
        break;
      await delayPromise(interval);
    }
  }
  isPoll() {
    return this.isPolling;
  }
  stop() {
    this.isPolling = false;
  }
}
var polling = new PollingService();
const os = function() {
  const ua2 = navigator.userAgent;
  const isWindowsPhone = /(?:Windows Phone)/.test(ua2);
  const isSymbian = /(?:SymbianOS)/.test(ua2) || isWindowsPhone;
  const isAndroid = /(?:Android)/.test(ua2);
  const isFireFox = /(?:Firefox)/.test(ua2);
  const isChrome = /(?:Chrome|CriOS)/.test(ua2);
  const isTablet = /(?:iPad|PlayBook)/.test(ua2) || isAndroid && !/(?:Mobile)/.test(ua2) || isFireFox && /(?:Tablet)/.test(ua2);
  const isPhone = /(?:iPhone)/.test(ua2) && !isTablet;
  const isPc = !isPhone && !isAndroid && !isSymbian;
  const isMobile = /AppleWebKit.*Mobile.*/.test(ua2);
  const isWechat = /MicroMessenger/i.test(ua2);
  const isIOS = /(iPhone|iPad|iPod|iOS)/i.test(ua2);
  return {
    isWindowsPhone,
    isSymbian,
    isAndroid,
    isFireFox,
    isChrome,
    isTablet,
    isPhone,
    isPc,
    isMobile,
    isWechat,
    isIOS
  };
}();
function getMonth(date) {
  return (date.getMonth() + 1).toString().padStart(2, "0");
}
function getDate(date) {
  return date.getDate().toString().padStart(2, "0");
}
function getHours(date) {
  return date.getHours().toString().padStart(2, "0");
}
function getMinutes(date) {
  return date.getMinutes().toString().padStart(2, "0");
}
function getSeconds(date) {
  return date.getSeconds().toString().padStart(2, "0");
}
function formatDate(timestamp, separator = "-", type = "seconds") {
  const now = new Date(timestamp);
  const year = now.getFullYear();
  const month = getMonth(now);
  const date = getDate(now);
  const hours = getHours(now);
  const minutes = getMinutes(now);
  const seconds = getSeconds(now);
  if (type === "date")
    return `${year}${separator}${month}${separator}${date}`;
  if (type === "minutes")
    return `${year}${separator}${month}${separator}${date} ${hours}:${minutes}`;
  return `${year}${separator}${month}${separator}${date} ${hours}:${minutes}:${seconds}`;
}
function calcDateDuration(start, end) {
  const leftTime = (end - start) / 1e3;
  const days = Math.floor(leftTime / 60 / 60 / 24);
  const hours = Math.floor(leftTime / 60 / 60 % 24);
  const minutes = Math.floor(leftTime / 60 % 60);
  const seconds = Math.floor(leftTime % 60);
  return { days, hours, minutes, seconds };
}
const ua = navigator.userAgent.toLowerCase();
const reg = {
  ie: /rv:([\d.]+)\) like gecko/,
  firfox: /firefox\/([\d.]+)/,
  chrome: /chrome\/([\d.]+)/,
  opera: /opera.([\d.]+)/,
  safari: /version\/([\d.]+).*safari/
};
const browser = [].concat(Object.keys(reg).filter((key) => reg[key].test(ua)))[0] || "";
export { polling as PollingService, browser, calcDateDuration, checkSourceValid, dataURLtoFile, deepClone, delayPromise, digitUppercase, download, downloadZip, encryptionPhone, filenameSuffix, formatDate, formatDurationTime, format as formatHelper, formatSize, get, getDate, getHours, getMinutes, getMonth, getSeconds, os, remove, set, store as storeHelper, tools as toolsHelper, validateChinese, validateCreditCode, validateEmail, validate as validateHelper, validateIdCard, validateLetter, validateLetterAndNumber, validateLetterOrNumber, validateNickname, validateNumber, validatePhone, validateRtmp, validateUrl };
